import React from "react";
import DashboardContent from "../FunctionalComponents/Dashboard/DashboardContent";

function Dashboard() {
  return (
    <>
      <DashboardContent />
    </>
  );
}

export default Dashboard;
